import "./style/sass/App.scss";
import Results from "./components/Results";
import Account from "./components/Account";
import Nav from "./components/Nav";
import QuestionIntro from "./components/QuestionIntro";
import Questions from "./components/Questions";
import Matches from "./components/Matches";
import Footer from "./components/Footer";
// import Filter from "./components/Filter";
import Home from "./components/Home";
import Profile from "./components/Profile";

import MentorConfirm from "./components/MentorConfirm";
// import { motion } from "framer-motion";
import {
  Routes,
  Route,
  useNavigate
} from "react-router-dom";
import firebase from "./firebase";
import {
  getDatabase,
  ref,
  onValue,
  set,
} from "firebase/database";
import { useEffect, useState } from "react";
import { AuthContextProvider } from "./context/AuthContext";

const App = () => {

   // Form state
  const [userData, setUserData] = useState({
    sportsOptions: "",
    introvertOptions: "",
    goalsOptions: "",
    bootcamp: "",
    firstName: "",
    lastName: "",
    expertise: "",
    pnoun: "",
    mentorType: "",
    connectType: "",
    skillsOptions: [],
    experienceOptions: "",
    image: [],
    bio: "",
    email: "",
    country: "Canada",
    timeZone: "Eastern",
    company: "",
    
    0: false,
    1: false,
    2: false,
    3: false,
  });

  // Filter state
  const [toggleFilter, setToggleFilter] = useState(false)
  const [firedata, setFiredata] = useState([]);
  const [filtered, setFiltered] = useState([]);
  // const { personalID } = useParams();
  const [professionChoice, setProfessionChoice] = useState("all");
  const [mentorChoice, setMentorChoice] = useState("mentor");
  const [skillsChoice, setSkillsChoice] = useState([
    "Designer",
    "Product Manager",
    "Developer",
  ]);

  const handleMentorStatus = () => {
    if (mentorChoice === "mentor") {
      setMentorChoice("mentee");
    } else {
      setMentorChoice("mentor");
    }
  };

    const [isOpen, setIsOpen] = useState(false);

  const navigate = useNavigate();

  const handleHomeSearch = () => {
console.log('home search')
  setToggleFilter(!toggleFilter)
  navigate("/results");
  }

  const handleResultsSearch = () => {
    
  setToggleFilter(!toggleFilter)
  setIsOpen(false)
  }


  useEffect(() => {
    const database = getDatabase(firebase);
    const dbRef = ref(database);
    onValue(dbRef, (response) => {
      const newState = [];
      const data = response.val();

      for (let key in data) {
        // pushing the values from the object into our newState array
        newState.push({ personalID: key, data: data[key] });
      }
      const mentorResults = newState.filter(
        (item) =>
          item.data.mentorType === "Mentor"
      );
      setFiredata(mentorResults);
      setFiltered(newState);
    });
  }, []);

  const handleProfessionChoice = (e, updatedprofession) => {
    if (updatedprofession !== null) {
      setProfessionChoice(updatedprofession);
    }
  };

  return (
    <>
        <Nav />
        <AuthContextProvider>
          <Routes>
            <Route
              path="/"
              element={
                <Home
                {...{
                  handleMentorStatus,
                  setMentorChoice,
                  mentorChoice,
                  handleProfessionChoice,
                  setProfessionChoice,
                  professionChoice,
                  setFiredata,
                  firedata,
                  userData,
                  setUserData,
                  handleHomeSearch,
                  handleResultsSearch,
                  toggleFilter,
                  setFiltered,
                  filtered,
                  skillsChoice,
                  setSkillsChoice,
                }}           
                />
              }
            />
            <Route />
            <Route
            path="/personal/:personalID"
              element={
                <Profile />
              }
            />
            <Route />
            <Route path="/results" 
            element={<Results 
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            handleHomeSearch={handleHomeSearch}
            handleResultsSearch={handleResultsSearch}
            routeHome={false}
            toggleFilter={toggleFilter} />} />
            <Route path="/matches" element={<Matches />} />
            <Route
              path="/questionintro"
              element={<QuestionIntro 
                userData={userData} />}
            />
            <Route
              path="/questions"
              element={
                <Questions
                  userData={userData}
                  setUserData={setUserData}
                />
              }
            />
            <Route path="/account" element={<Account />} />
          
            <Route 
              path="/success" 
              element={<MentorConfirm />}
            />
          </Routes>
        </AuthContextProvider>
        <Footer />
    </>
  );
};

export default App;
